import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { NacoService } from '../domains/services/naco.service';
import { first, map } from 'rxjs/internal/operators';
import { User } from '../domains/models/user';
import { Observable } from 'rxjs';
import { Storage } from '@ubud/storage';
import { Location } from '@angular/common';

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanActivateChild {
    public constructor(private naco: NacoService, private storage: Storage, private location: Location) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.naco.getUser().pipe(
            first(),
            map((user: User | null) => {
                if (null === user) {
                    this.naco.goToAccountEndpoint(route.root);
                }

                return !!user;
            }),
        );
    }

    public canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.canActivate(route);
    }
}
